import React, { useState, /*useRef,*/ useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import DateTimePicker from '@mui/lab/DateTimePicker';

import { selectUid/*, selectToken*/ } from '../login/LoginSlice';
import { getChecksDataAsync, selectChecksData } from './CheckSlice';
//import { selectPrjId, selectPrjName } from '../summary/SummarySlice';
import { selectPrj } from '../summary/SummarySlice';


const CheckIcon = ({status}) => {
    switch (status) {
        case 'ok':
            return (<i className="material-icons icon-green">check_circle</i>);
        case 'ng':
            return (<i className="material-icons icon-red">error</i>);
        case 'warn':
            return (<i className="material-icons icon-yellow">warning</i>);
        default:
            return (<i className="material-icons icon-gray">help</i>);
    }
};

const SiteCheckRows = ({siteCheckIds, checks, ...props}) => {
    const rows = siteCheckIds.map((id, index) => {
        const check = checks[id];
        
        return (
          <TableRow>
            <TableCell>
                <CheckIcon status={check.status}/>
            </TableCell>
            <TableCell>{check.eventName}</TableCell>
            <TableCell>{check.siteType}</TableCell>
            <TableCell>{check.server}</TableCell>
            <TableCell>{check.checkTime}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const SiteCheckTable = ({siteCheckIds, checks, ...props}) => {
    if (siteCheckIds.length === 0)
        return (<div></div>);

        return (
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell colSpan={5}>
              <Typography>SITE</Typography>
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell>Status</TableCell>
            <TableCell>Event Name</TableCell>
            <TableCell>Site Type</TableCell>
            <TableCell>Server</TableCell>
            <TableCell>Ckeck Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <SiteCheckRows checks={checks} siteCheckIds={siteCheckIds}/>
        </TableBody>
      </Table>
    );
}

const BatchCheckRows = ({batchCheckIds, checks, ...props}) => {
    const rows = batchCheckIds.map((id, index) => {
        const check = checks[id];
        
        return (
          <TableRow>
            <TableCell>
                <CheckIcon status={check.status}/>
            </TableCell>
            <TableCell>{check.eventName}</TableCell>
            <TableCell>{check.batchName}</TableCell>
            <TableCell>{check.jobName}</TableCell>
            <TableCell>{check.checkTime}</TableCell>
            <TableCell>{check.start}</TableCell>
            <TableCell>{check.end}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const BatchCheckTable = ({batchCheckIds, checks,...props}) => {
    if (batchCheckIds.length === 0)
        return (<div></div>);

        return (
        <Table size="small">
          <TableHead>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell colSpan={5}>
                <Typography>Batch</Typography>
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell>Status</TableCell>
              <TableCell>Event Name</TableCell>
              <TableCell>Batch Name</TableCell>
              <TableCell>Job Name</TableCell>
              <TableCell>Ckeck Time</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <BatchCheckRows checks={checks} batchCheckIds={batchCheckIds}/>
          </TableBody>
        </Table>
    );
};

const MaintCheckRows = ({maintCheckIds, checks, ...props}) => {
    const rows = maintCheckIds.map((id, index) => {
        const check = checks[id];
        
        return (
          <TableRow>
            <TableCell>
                <CheckIcon status={check.status}/>
            </TableCell>
            <TableCell>{check.eventName}</TableCell>
            <TableCell>{check.target}</TableCell>
            <TableCell>{check.checkTime}</TableCell>
            <TableCell>{check.start}</TableCell>
            <TableCell>{check.end}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const MaintCheckTable = ({maintCheckIds, checks, ...props}) => {
    
    if (maintCheckIds.length === 0)
        return (<div></div>);
    
    return (
        <Table size="small">
          <TableHead>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell colSpan={5}>
                <Typography>Maintenance</Typography>
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell>Status</TableCell>
              <TableCell>Event Name</TableCell>
              <TableCell>Batch Name</TableCell>
              <TableCell>Job Name</TableCell>
              <TableCell>Ckeck Time</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <MaintCheckRows checks={checks} maintCheckIds={maintCheckIds}/>
          </TableBody>
        </Table>
      );
}

const CheckList = ({ ...props }) => {
    const dispatch = useDispatch();

    const uid = useSelector(selectUid);
    //const token = useSelector(selectToken);
    //const prjId = useSelector(selectPrjId);
    //const prjName = useSelector(selectPrjName);
    const prj = useSelector(selectPrj);
    const checksData = useSelector(selectChecksData);

    const [targetDt, setTargetDt] = useState(new Date());


    const loadItems = () => {
        dispatch(getChecksDataAsync({ 
            /*token: token,*/ uid: uid, prjId:prj.prjId, targetDt: targetDt.toISOString() }));
    };

    useEffect(() => {
        loadItems();

        const interval = setInterval(() => {
            loadItems();
        }, 60000);
        return () => clearInterval(interval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div>
            <DateTimePicker renderInput={(params) => <TextField {...params} />} />
            <TableContainer>
                <BatchCheckTable batchCheckIds={checksData.batchCheckIds} checks={checksData.checks}/>
                <MaintCheckTable maintCheckIds={checksData.maintCheckIds} checks={checksData.checks}/>
                <SiteCheckTable siteCheckIds={checksData.siteCheckIds} checks={checksData.checks}/>
            </TableContainer>    
        </div>
    );
};

export default CheckList;
